var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.437 18.001C8.101 19.073 8.06 20.142 8.234 21.162L7.31096 21.591L6.20098 19.689C2.25098 12.955 -0.355026 8.50098 0.911974 4.46098C1.94897 1.14998 5.352 -0.620044 8.653 0.414956C10.518 0.999956 12.035 2.42898 12.777 4.15598C14.371 3.16098 16.433 2.85397 18.298 3.43797C21.598 4.47297 23.382 7.86797 22.344 11.18C21.864 12.712 20.881 13.969 19.484 15.1209C18.766 14.4479 17.889 13.902 16.882 13.587C13.335 12.475 9.548 14.454 8.437 18.001ZM17.282 16.066L15.138 15.394L14.131 18.609L10.916 17.601L10.244 19.744L13.459 20.752L12.451 23.967L14.594 24.639L15.602 21.424L18.817 22.432L19.489 20.288L16.274 19.281L17.282 16.066Z",
    fill: "#E59411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.3883716f67c14edd730577a13c9360ff.svg";
export { ForwardRef as ReactComponent };